import { FC, JSX } from 'react'
import { CompanyAvatar, CompanyAvatarType } from './Avatar'
import { CompanyRollingDays, CompanyRollingDaysType } from './rollingDays'

export const Company: FC &
  CompanyAvatarType &
  CompanyRollingDaysType = (): JSX.Element => <></>

Company.Avatar = CompanyAvatar
Company.RollingDays = CompanyRollingDays
